import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject, BehaviorSubject, map, of, finalize } from 'rxjs';
import { ConfigService } from '../../app-config.service';
import { CommonMethods, Severity } from '../helpers';
import { AuthenticationService } from './authenticate.service';
import { SpinnerService } from './spinner.service';
import { any } from '@amcharts/amcharts5/.internal/core/util/Array';

@Injectable({
  providedIn: 'root'
})
export class CommonHttpService {
  private readonly exportJobQueuedSubject = new Subject<void>();
  readonly exportJobQueued$ = this.exportJobQueuedSubject.asObservable();

  getUsers() {
    throw new Error('Method not implemented.');
  }
  constructor(
    private _httpClient: HttpClient,
    private _commonMethods: CommonMethods,
    private _configService: ConfigService,
    private _authenticationService: AuthenticationService,
    private _spinnerService: SpinnerService,
  ) {

  }

  private emptyMyJobsResponse = {
    data: [],
    summary: { pending: 0, processing: 0, completed: 0, failed: 0, cancelled: 0 },
  };


  /* Code block Added by Anil Kumar Boddu on 29/07/2025 
  This is used to set and get the reports
  */
  public getReports = new BehaviorSubject<any>(null);
  reportsData = this.getReports.asObservable();
  setReportsData(data: any) {
    this.getReports.next(data);
  }
  /* End of Code block Added by Anil Kumar Boddu on 29/07/2025  */

  getUserConfig() {
    const url = this._configService.get.call(this._configService, 'platform').servicesBaseUrl;
    const thDomain = this._configService.get.call(this._configService, 'platform').thDomain;
    return this._httpClient.get<any>(url + '/configuration/get-configuration').pipe(map(data => {
      if (data.status === 1) {
        return data.data;
      } else {
        this._commonMethods.showToastMessage(data.message, '', Severity.error as Severity);
      }
      return data;
    }));
  }

  /*
  * This function is used to get the landing screent report listing
  * @author Chari on 05/27/2025
  */
  getReportsList(category: string) {
    const url = this._configService.get.call(this._configService, 'platform').servicesBaseUrl;

    return this._httpClient.get<any>(url + '/report-details/' + category).pipe(map(data => {
      if (data.status === 1) {
      } else {
        this._commonMethods.showToastMessage(data.message, '', Severity.error as Severity);
      }
      return data;
    }));
  }

  /*
  * This function is used to get the landing screent favorite reports listing
  * @author Chari on 05/29/2025
  */
  getFavoriteReportsList() {
    const url = this._configService.get.call(this._configService, 'platform').servicesBaseUrl;

    return this._httpClient.get<any>(url + '/report-details/favourite-recent-reports').pipe(map(data => {
      if (data.status === 1) {
      } else {
        this._commonMethods.showToastMessage(data.message, '', Severity.error as Severity);
      }
      return data;
    }));
  }

  /*
  * This function is used to get the landing screent recent reports listing
  * @author Chari on 05/29/2025
  */
  getRecentReportsList() {
    const url = this._configService.get.call(this._configService, 'platform').servicesBaseUrl;

    return this._httpClient.get<any>(url + '/report-details/recent-reports').pipe(map(data => {
      if (data.status === 1) {
      } else {
        this._commonMethods.showToastMessage(data.message, '', Severity.error as Severity);
      }
      return data;
    }));
  }

  /*
  * This method is used to update the favorite for the report
  * @author Chari on 06/05/2025
  */
  updateFavourite(data: any) {
    const url = this._configService.get.call(this._configService, 'platform').servicesBaseUrl;
    console.log(data);
    return this._httpClient.post<any>(url + '/report-details/save-fav-report', data).pipe(map(data => {
      if (data.status === 1) {
      } else {
        this._commonMethods.showToastMessage(data.message, '', Severity.error as Severity);
      }
      return data;
    }));
  }

  /*
  * This method is used to update the favorite for the report
  * @author Chari on 06/06/2025
  */
  tagAndUntagReport(data: any) {
    data.isTaggedReport = (data.isTaggedReport == 0) ? 1 : 0;
    const url = this._configService.get.call(this._configService, 'platform').servicesBaseUrl;
    return this._httpClient.post<any>(url + '/report-details/update-tagging-report', data).pipe(map(data => {
      if (data.status === 1) {
      } else {
        this._commonMethods.showToastMessage(data.message, '', Severity.error as Severity);
      }
      return data;
    }));
  }

  /*
  * This method is used to the report
  * @author Chari on 06/09/2025
  */
  deleteReport(params: any) {
    let url = this._configService.get.call(this._configService, 'platform').servicesBaseUrl;
    if (params.currentTab == '0') {
      url = url + '/report-details/delete-saved-report/' + params.id;
    } else if (params.currentTab == '2') {
      url = url + '/report-details/delete-report-automation/' + params.id;
    }
    return this._httpClient.delete<any>(url).pipe(map(data => {
      if (data.status === 1) {
      } else {
        this._commonMethods.showToastMessage(data.message, '', Severity.error as Severity);
      }
      return data;
    }));
  }

  private notifyExportProgressIfNeeded(response: any): void {
    if (response?.showExportProgress === true) {
      this.exportJobQueuedSubject.next();
    }
  }

  getReportConfig(data: any) {
    const url = this._configService.get.call(this._configService, 'platform').servicesBaseUrl;
    return this._httpClient.post<any>(url + '/report-details/get-report-config', data).pipe(map(data => {
      if (data.status === 1) {
        return data.data;
      } else {
        this._commonMethods.showToastMessage(data.message, '', Severity.error as Severity);
      }
      return data;
    }));
  }

  getConversionRatioField() {
    const url = this._configService.get.call(this._configService, 'platform').servicesBaseUrl;
    return this._httpClient.get<any>(url + '/report-details/get-conversion-ratio-field').pipe(map(data => {
      return data;
    }));
  }

  getUsersList(businessUnitIds: Array<number | string> = []) {
    const url = this._configService.get.call(this._configService, 'platform').servicesBaseUrl;
    return this._httpClient.post<any>(url + '/report-details/get-users-list', { businessUnitIds }).pipe(map(data => {
      return data;
    }));
  }

  getReportData(reportFormData: any) {
    const url = this._configService.get.call(this._configService, 'platform').servicesBaseUrl;

    return this._httpClient.post<any>(url + '/report-details/get-report', { ...reportFormData }).pipe(map(data => {
      this.notifyExportProgressIfNeeded(data);
      if (data.status === 1) {
        return data;
      } else {
        this._commonMethods.showToastMessage(data.message, '', Severity.error as Severity);
      }
      return data;
    }));
  }

  makeFilterDropDowns(data: any) {
    const url = this._configService.get.call(this._configService, 'platform').servicesBaseUrl;
    this._spinnerService.show('Loading filter options...');
    return this._httpClient.post<any>(url + '/filter-dropdown/generate', data, {
      headers: { 'X-Skip-Spinner': 'true' }
    }).pipe(
      map(data => data),
      finalize(() => this._spinnerService.hide())
    );
  }

  generateCustomReportApi(savedReportId: number) {
    const url = this._configService.get.call(this._configService, 'platform').servicesBaseUrl;
    return this._httpClient.post<any>(url + '/report-details/generate-custom-report-api', { savedReportId }, {
      headers: { 'X-Skip-Spinner': 'true' }
    }).pipe(map(data => {
      return data;
    }));
  }

  getSavedReportData(data: any) {
    const url = this._configService.get.call(this._configService, 'platform').servicesBaseUrl;
    return this._httpClient.get<any>(url + '/report-details/get-saved-report/' + data.reportId).pipe(map(data => {
      if (data.status === 1) {
        return data.data;
      } else {
        this._commonMethods.showToastMessage(data.message, '', Severity.error as Severity);
      }
      return data;
    }));
  }

  getRoleWiseUsersList(businessUnitIds: any = []) {
    const url = this._configService.get.call(this._configService, 'platform').servicesBaseUrl;
    return this._httpClient.post<any>(url + '/configuration/get-teams-and-roles', { businessUnitIds: businessUnitIds }).pipe(map(data => {
      if (data.status === 1) {
        return data.data;
      } else {
        this._commonMethods.showToastMessage(data.message, '', Severity.error as Severity);
      }
      return data;
    }));
  }

  /* Code Added by Anil Kumar Boddu to get report search data on Jul 30 2025 */
  getReportSearchData(data: any) {
    console.log("getReportSearchData", data);
    const url = this._configService.get.call(this._configService, 'platform').servicesBaseUrl;
    return this._httpClient.post<any>(url + '/report-details/report-search', data).pipe(map(data => {
      return data;
    }));
  }

  /* Code Added by Anil Kumar Boddu to get time zones, users, roles, teams  data on Jul 30 2025 */
  getTimeZones() {
    const url = this._configService.get.call(this._configService, 'platform').servicesBaseUrl;
    return this._httpClient.get<any>(url + '/report-details/report-automation-popup-info').pipe(map(data => {
      return data;
    }));
  }

  /* Code Added by Anil Kumar Boddu to save report automation data on Aug 1 2025 */
  saveReportAutomation(data: any) {
    const url = this._configService.get.call(this._configService, 'platform').servicesBaseUrl;
    return this._httpClient.post<any>(url + '/report-details/save-report-automation', data).pipe(map(data => {
      if (data.status === 1) {
        return data;
      } else {
        this._commonMethods.showToastMessage(data.message, data.message, Severity.error as Severity);
      }
      return data;
    }));
  }

  /* Code Added by Anil Kumar Boddu to get scheduled saved reports data on Aug 1 2025 */
  getScheduledSavedReports(savedReportId: any = null) {
    const url = this._configService.get.call(this._configService, 'platform').servicesBaseUrl;
    return this._httpClient.get<any>(url + '/report-details/scheduled-reports?savedReportId=' + savedReportId).pipe(map(data => {
      return data;
    }));
  }

  deleteScheduledReport(reportId: any = null) {
    const url = this._configService.get.call(this._configService, 'platform').servicesBaseUrl;
    return this._httpClient.delete<any>(url + '/report-details/delete-report-automation/' + reportId).pipe(map(data => {
      return data;
    }));
  }

  getTalentBenchReportOptions() {
    const url = this._configService.get.call(this._configService, 'platform').servicesBaseUrl;
    return this._httpClient.get<any>(url + '/configuration/get-talent-bench-report-options').pipe(map(data => {
      return data;
    }));
  }

  saveReport(data: any) {
    const url = this._configService.get.call(this._configService, 'platform').servicesBaseUrl;
    return this._httpClient.post<any>(url + '/report-details/save-report', data).pipe(map(data => {
      return data.data;
    }));
  }

  getUserList(data: any) {
    const url = this._configService.get.call(this._configService, 'platform').servicesBaseUrl;
    return this._httpClient.post<any>(url + '/report-details/report-level-security-popup-info', data).pipe(map(data => {
      return data;
    }));
  }
  saveReportSecurity(data: any) {
    const url = this._configService.get.call(this._configService, 'platform').servicesBaseUrl;
    return this._httpClient.post<any>(url + '/report-details/save-report-level-security', data).pipe(map(data => {
      return data.data;
    }));
  }
  // getReportSecurity(reportId: any = null){
  //   const url = this._configService.get.call(this._configService, 'platform').servicesBaseUrl;
  //   return this._httpClient.get<any>(url + '/report-details/get-report-level-security-info/' + reportId).pipe(map(data => {
  //     return data;
  //   }));
  // }

  getUsersWithEmail() {
    const url = this._configService.get.call(this._configService, 'platform').servicesBaseUrl;
    return this._httpClient.get<any>(url + '/configuration/get-user-and-email-ids').pipe(map(data => {
      return data;
    }));
  }

  getDrilldownColumns(drilldownObject: any = {}) {
    const url = this._configService.get.call(this._configService, 'platform').servicesBaseUrl;
    return this._httpClient.post<any>(url + '/report-details/get-report-drilldown-table', drilldownObject).pipe(map(data => {
      return data;
    }));
  }

  getDrilldownReportData(data: any) {
    const url = this._configService.get.call(this._configService, 'platform').servicesBaseUrl;
    return this._httpClient.post<any>(url + '/report-details/get-drilldown-report', data).pipe(map(data => {
      this.notifyExportProgressIfNeeded(data);
      return data;
    }));
  }
  
  getConvertedTimezone(data: any) {
    const url = this._configService.get.call(this._configService, 'platform').servicesBaseUrl;
    return this._httpClient.post<any>(url + '/report-details/check-timezone-est-time', data).pipe(map(data => {
      return data;
    }));
  }

  saveMobileReport(data: any) {
    const url = this._configService.get.call(this._configService, 'platform').servicesBaseUrl;
    return this._httpClient.post<any>(url + '/report-details/save-mobile-report', data).pipe(map(data => {
      return data;
    }));
  }

  getApiConfig() {
    const url = this._configService.get.call(this._configService, 'platform').servicesBaseUrl;
    return this._httpClient.get<any>(url + '/report-details/get-api-config/').pipe(map(data => {
      return data;
    }));
  }
  getJobDescription(data: any) {
    const url = this._configService.get.call(this._configService, 'platform').servicesBaseUrl;
    return this._httpClient.get<any>(url + '/report-details/get-description/' + data.primaryKey + '/' + data.column).pipe(map(data => {
      return data;
    }));
  }

  changeDefaultSetting() {
    const url = this._configService.get.call(this._configService, 'platform').servicesBaseUrl;
    return this._httpClient.post<any>(url + '/report-details/update-ceipal-bi-preference', {}).pipe(map(data => {
      return data;
    }));
  }

  getFormDataForClassicBI() {
    const url = this._configService.get.call(this._configService, 'platform').servicesBaseUrl;
    return this._httpClient.get<any>(url + '/report-details/get-form-data-for-classic-bi').pipe(map(data => {
      return data;
    }));
  }

  /*
  * This method is used to get the ongoing export jobs for the current user
  * @author Raghava on 04/13/2026
  */
  getMyJobs() {
    if (!this._authenticationService.isAuthTokenReady || !this._authenticationService.getBearerToken()) {
      return of(this.emptyMyJobsResponse);
    }

    const url = this._configService.get.call(this._configService, 'platform').servicesBaseUrl;
    return this._httpClient.get<any>(url + '/report-details/export/my-jobs', {
      headers: { 'X-Skip-Spinner': 'true' }
    }).pipe(map(data => {
      return data;
    }));
  }

  /**
   * Opens an SSE stream for export job updates.
   * Uses fetch (not EventSource) so the Bearer token can be sent in headers.
   */
  openMyJobsStream(handlers: {
    onMessage: (payload: any) => void;
    onError?: (error: unknown) => void;
    onClose?: () => void;
  }): AbortController {
    const baseUrl = this._configService.get.call(this._configService, 'platform').servicesBaseUrl;
    const controller = new AbortController();
    const token = this._authenticationService.getBearerToken();

    if (!this._authenticationService.isAuthTokenReady || !token) {
      handlers.onClose?.();
      return controller;
    }

    fetch(`${baseUrl}/report-details/export/my-jobs/stream`, {
      method: 'GET',
      headers: {
        Accept: 'text/event-stream',
        Authorization: `Bearer ${token}`,
      },
      signal: controller.signal,
    })
      .then(async (response) => {
        if (!response.ok) {
          if (response.status === 401) {
            this._authenticationService.handleUnauthorizedSession();
            handlers.onClose?.();
            return;
          }
          throw new Error(`SSE connection failed (${response.status})`);
        }
        if (!response.body) {
          throw new Error('SSE response body is empty');
        }

        const reader = response.body.getReader();
        const decoder = new TextDecoder();
        let buffer = '';

        while (true) {
          const { done, value } = await reader.read();
          if (done) break;

          buffer += decoder.decode(value, { stream: true });
          buffer = this.consumeSseBuffer(buffer, handlers.onMessage);
        }

        handlers.onClose?.();
      })
      .catch((error) => {
        if (controller.signal.aborted) {
          handlers.onClose?.();
          return;
        }
        handlers.onError?.(error);
      });

    return controller;
  }

  private consumeSseBuffer(buffer: string, onMessage: (payload: any) => void): string {
    const events = buffer.split('\n\n');
    const remainder = events.pop() ?? '';

    for (const rawEvent of events) {
      const dataLines = rawEvent
        .split('\n')
        .filter((line) => line.startsWith('data:'))
        .map((line) => line.slice(5).trimStart());

      if (dataLines.length === 0) continue;

      const payloadText = dataLines.join('\n');
      if (!payloadText || payloadText === '[DONE]') continue;

      try {
        onMessage(JSON.parse(payloadText));
      } catch {
        // Ignore malformed SSE frames.
      }
    }

    return remainder;
  }

  cancelJob(jobId: string) {
    const url = this._configService.get.call(this._configService, 'platform').servicesBaseUrl;
    return this._httpClient.delete<any>(`${url}/report-details/export/job/${jobId}`, {
      headers: { 'X-Skip-Spinner': 'true' }
    }).pipe(map(data => {
      return data;
    }));
  }
}
